import { render, staticRenderFns } from "./StoryBackground.vue?vue&type=template&id=2fd50240&"
import script from "./StoryBackground.vue?vue&type=script&lang=js&"
export * from "./StoryBackground.vue?vue&type=script&lang=js&"
import style0 from "./StoryBackground.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/components/StoryBackground.vue
// module id = 1047
// module chunks = 0